import { Component, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { Observable } from 'rxjs';
import { MapService } from '../../components/molecules/map/service/map.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-map-confirm',
  templateUrl: './map-confirm.component.html',
  styleUrls: ['./map-confirm.component.scss'],
})
export class MapConfirmComponent implements OnInit {
  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  submitted: boolean;
  mapForm: FormGroup;
  isBSAS: boolean = false;
  showStateWarning: boolean = false;
  mapOptions: any = {
    center: { lat: -34.603722, lng: -58.381592 },
    zoom: 17,
    mapTypeControlOptions: { mapTypeIds: [] },
    disableDefaultUI: true,
    mapTypeControl: true,
    scaleControl: true,
    mapTypeId: 'roadmap',
    clickableIcons: false,
    draggableCursor: 'crosshair',
  };
  zoom: number;
  markerPosition: any = null;
  apiLoaded: Observable<boolean>;
  showErrorConfirm: boolean = false;
  editingMarker: boolean = false;
  constructor(
    public dialog: MatDialogRef<MapConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { coordinates: any; address: string},
    private fb: FormBuilder,
    private mapService: MapService,
  ) {
    this.zoom = 17;
    this.submitted = false;
    if (data.coordinates) {
      this.mapOptions.center = { lat: data.coordinates.lat, lng: data.coordinates.lon };
      this.markerPosition = {
        lat: data.coordinates.lat,
        lng: data.coordinates.lon,
      };
    }
    this.apiLoaded = mapService.googleMapsDinamicApi();
    this.mapForm = this.fb.group({
      locationStreet: [data.address, Validators.maxLength(60)],
    });
  }

  zommChangedMap() {
    this.zoom = this.map.getZoom() ?? 17;
  }

  ngOnInit(): void {}

  mapClick(event: any) {
    if (this.editingMarker) {
      let latLng = event.latLng.toJSON();
      console.log('latLNG', latLng);
      this.markerPosition = latLng;
      this.zoom = this.zoom < 17 ? 17 : this.zoom;
      if (this.map) this.map.panTo(latLng);
    }
  }

  confirm() {
    if (!this.mapForm.get('locationStreet')?.valid) {
      this.showErrorConfirm = true;
      return;
    }
    this.save();
    this.showErrorConfirm = false;
    this.editingMarker = false;
  }

  save() {
    const response = {
      coordinates : {
        lat:this.markerPosition.lat,
        lon:this.markerPosition.lng,
      },       
      street: this.mapForm.get('locationStreet')?.value,
    };
    this.dialog.close(response);
  }

  close() {
    this.dialog.close();
  }
}
